"use client";
import React from "react";
import { Feature } from "../types/synergyTypes";

interface FeaturesGridProps {
  placeholder: {
    text?: string;
    image?: string;
  };
  features: Feature[];
}

const FeaturesGrid: React.FC<FeaturesGridProps> = ({
  placeholder,
  features,
}) => (
  <section className="bg-white py-16">
    <div className="mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 pt-4 items-center">
      <div className="w-full h-[535px] flex items-center justify-center rounded-md border border-neutral-200 overflow-hidden">
        {placeholder.image ? (
          // eslint-disable-next-line @next/next/no-img-element
          <img
            src={placeholder.image}
            alt="Features placeholder"
            className="w-full h-full object-contain"
          />
        ) : (
          <span className="text-neutral-400 text-xl">{placeholder.text}</span>
        )}
      </div>
      <div className="flex flex-col gap-10">
        {features.map((feature) => (
          <div key={feature.title} className="flex items-start gap-6">
            {feature.image && (
              <img
                src={feature.image}
                alt={feature.title}
                className="w-[89px] h-[90px] object-contain"
              />
            )}
            <div>
              <h3 className="text-3xl font-semibold mb-1">{feature.title}</h3>
              <p className="text-neutral-500 text-base leading-snug max-w-[345px]">
                {feature.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default FeaturesGrid;
